import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef, useCallback } from 'react';
import FocusLock from 'react-focus-lock';
import { jsx } from '@emotion/react';

const FocusTrap = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const {
    disabled = false,
    initializeFocus = false,
    initializeFocusRef,
    restoreFocus = true,
    restoreFocusRef,
    allowFocusList,
    style,
    children
  } = props;
  const onActivation = useCallback(() => {
    initializeFocusRef?.current?.focus();
  }, [initializeFocusRef]);
  const onDeactivation = useCallback(() => {
    restoreFocusRef?.current?.focus();
  }, [restoreFocusRef]);
  return jsx(FocusLock, _extends({
    ref: forwardedRef,
    disabled: disabled
    // eslint-disable-next-line jsx-a11y/no-autofocus
    ,
    autoFocus: initializeFocus && !initializeFocusRef,
    returnFocus: restoreFocus && !restoreFocusRef,
    onActivation: onActivation,
    onDeactivation: onDeactivation,
    shards: allowFocusList
  }, style ? {
    lockProps: {
      style
    }
  } : null), children);
});
FocusTrap.displayName = "FocusTrap";

export { FocusTrap };
